import { GitStatusWidget } from "./GitStatusWidget";
import { GitPushResultWidget } from "./GitPushResultWidget";
import { GitHubConnectWidget } from "./GitHubConnectWidget";
import { GitHubStatusWidget } from "./GitHubStatusWidget";
import { GitHubRepoPickerWidget } from "./GitHubRepoPickerWidget";
import { GitHubRepoConnectedWidget } from "./GitHubRepoConnectedWidget";
import { TaskListWidget } from "./TaskListWidget";
import { TaskAddedWidget } from "./TaskAddedWidget";
import { TaskUpdatedWidget } from "./TaskUpdatedWidget";
import { ApprovalWidget } from "./ApprovalWidget";
import { Card } from "@/components/ui/card";

interface WidgetAction {
  id: string;
  label: string;
  style?: string;
}

interface WidgetRendererProps {
  widgetType: string;
  data: Record<string, unknown>;
  actions?: WidgetAction[];
  onAction?: (actionId: string, context?: Record<string, unknown>) => void;
}

/**
 * Routes widget payloads to the correct visual component.
 * Unknown widget types render a minimal fallback card.
 */
export function WidgetRenderer({ widgetType, data, actions, onAction }: WidgetRendererProps) {
  switch (widgetType) {
    case "git_status":
      return (
        <GitStatusWidget
          data={data as any}
          actions={actions}
          onAction={onAction}
        />
      );

    case "git_push_result":
      return <GitPushResultWidget data={data as any} />;

    case "github_connect":
      return <GitHubConnectWidget />;

    case "github_status":
      return (
        <GitHubStatusWidget
          data={data as any}
          actions={actions}
          onAction={onAction}
        />
      );

    case "github_repo_picker":
      return (
        <GitHubRepoPickerWidget
          data={data as any}
          onAction={onAction}
        />
      );

    case "github_repo_connected":
      return <GitHubRepoConnectedWidget data={data as any} />;

    case "task_list":
      return <TaskListWidget data={data as any} onAction={onAction} />;

    case "task_added":
      return <TaskAddedWidget data={data as any} />;

    case "task_updated":
      return <TaskUpdatedWidget data={data as any} />;

    case "task_deleted":
      // Minimal confirmation — no dedicated component needed
      return (
        <Card variant="default" padding="sm" className="max-w-md animate-slide-up">
          <p className="text-sm text-intri-dim">Task removed</p>
        </Card>
      );

    case "approval_request":
      return <ApprovalWidget data={data as any} onAction={onAction} />;

    default:
      // Fallback for unknown widget types — render raw data
      return (
        <Card variant="default" padding="sm" className="max-w-md animate-slide-up">
          <p className="text-2xs text-intri-muted font-mono">
            {widgetType}: {JSON.stringify(data, null, 2)}
          </p>
        </Card>
      );
  }
}
